<template>
  <b-col style="color: grey">
    <b-row
      v-for="(rate, index) in ratingDistribution"
      :key="index"
      style="border-bottom: 1px solid grey"
    >
      <b-col class="pr-0">
        {{ rate.Rating}}
        {{$t('Webportal.CX.Dashboard.Exploration.Stars')}}
      </b-col>
      <b-col class="pl-0 vert-centered">
        <b-progress
          :variant="variant"
          :height="barHeight"
          :style="'background-color:' + barBGColor"
          class="mx-0 px-0"
          max="100"
        >
          <b-progress-bar :value="rate.Percent" />
        </b-progress>
      </b-col>
      <b-col class="pl-0">{{rate.Percent}}%</b-col>
    </b-row>
    <b-row class="distribution-subtitle">
      <b-col>
        {{subtitle}}
      </b-col>
    </b-row>
    
    <!-- Facebook details -->
    <b-row v-if="facebookData" class="fb-stats">
      <div>
        <div><font-awesome-icon class="mx-0" :icon="['far', 'thumbs-up']" /><span> {{ $t('Webportal.CX.Dashboard.Exploration.Mobile.Likes')}}: {{ facebookData.Likes }}</span></div>
        <div><font-awesome-icon class="mx-0" :icon="['far', 'rss']" /><span> {{ $t('Webportal.CX.Dashboard.Exploration.Mobile.Subscribers')}}: {{ facebookData.Subscriptions }}</span></div>
        <div><font-awesome-icon class="mx-0" :icon="['far', 'map-marker-check']" /><span> {{ $t('Webportal.CX.Dashboard.Exploration.Mobile.Visits')}}: {{ facebookData.Visits }}</span></div>
      </div>
    </b-row>
  </b-col>
</template>

<script>
  export default {
    name: "RatingDistribution",
    components: { },
    props: {
      variant: {
        type: String,
        default: "dark",
      },
      barHeight: {
        type: String,
        default: "8px",
      },
      barBGColor: {
        type: String,
        default: "#777",
      },
      subtitle: {
        type: String,
        default: function() {
          return this.$t("Webportal.CX.Dashboard.Exploration.RatingDistribution.Subtitle");
        },
      },
      reviewArray: {
        type: Array,
        default: () => [],
      },
      reviewsRatingField: {
        type: String,
        default: "Value",
      },
      facebookData: { type: Object, default: () => null }
    },
    data() {
      return {
        fallbackDistribution: [
          { Rating: 1, Percent: 0},
          { Rating: 2, Percent: 0},
          { Rating: 3, Percent: 0},
          { Rating: 4, Percent: 0},
          { Rating: 5, Percent: 0},
        ],
      };
    },
    computed: {
      ratingDistribution: function() {
        if (!this?.reviewArray?.length)
          return this.fallbackDistribution;

        let result = this.reviewArray.map((el) => {
          return el[this.reviewsRatingField];
        });

        let ratingDistribution = _.countBy(result, Math.round);
        for (let i = 1; i <= 5; ++i) {
          ratingDistribution[i] = ratingDistribution[i] || 0;
        }

        let distributionArray = [];
        _.forIn(ratingDistribution, (value, key) => {
          distributionArray.push({
            Percent: Math.round((value / this.reviewArray.length) * 100),
            Rating: parseInt(key),
          });
        });

        return distributionArray;
      },
    }
  };
</script>

<style scoped>
  .distribution-subtitle {
    text-align: center;
    font-style: italic;
    font-size: 0.75rem;
  }

  .vert-centered {
    margin-bottom: auto;
    margin-top: auto;
  }

  .fb-stats {
    text-align: left;
    font-style: normal;
    font-size: 1.0em;
    min-height: 4rem;
    padding-left: 0.5rem;
    padding-top: 0.175rem;
  }
</style>
